import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const Gender = () => {
    const { chartData } = useIdentificationChartsDataContext();

    return (
        <Donut
            title={'Sexo'}
            subtitles={chartData?.gender?.map((item) => item.description)}
            chartData={chartData?.gender || []}
            colors={defaultColors.slice(0, chartData?.gender?.length) || []}
            height={400}
        />
    );
};
